import React from 'react';

const PrelitXLogo = ({ size = 'medium', className = '' }) => {
  const sizeClasses = {
    small: 'h-10',
    medium: 'h-12',
    large: 'h-16',
    xlarge: 'h-24'
  };

  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/assets/branding/prelit-x-logo.jpg" 
        alt="Prelit X Medical Logo" 
        className={`${sizeClasses[size]} w-auto object-contain`}
        style={{ 
          filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))'
        }}
      />
      <div className="ml-3 flex flex-col">
        <span 
          className="font-bold tracking-tight"
          style={{ 
            color: '#245451',
            fontSize: size === 'small' ? '18px' : size === 'medium' ? '22px' : size === 'large' ? '26px' : '32px',
            lineHeight: '1.2'
          }}
        >
          Prelit X
        </span>
        <span 
          className="font-semibold tracking-widest"
          style={{ 
            color: '#406962',
            fontSize: size === 'small' ? '8px' : size === 'medium' ? '10px' : size === 'large' ? '12px' : '14px',
            letterSpacing: size === 'small' ? '1px' : '1.5px'
          }}
        >
          MEDICAL
        </span>
      </div>
    </div>
  );
};

export default PrelitXLogo;
